import React from 'react';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { Card } from 'antd';
import { request } from '../../core/axios/axios';
import styles from './styles/index.module.scss';

interface GoogleAuthProps {
  onSuccess?: () => void;
}

const GoogleAuth = ({ onSuccess }: GoogleAuthProps) => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (!clientId) {
    throw new Error('No clientId provided!');
  }
  return (
    <div className={styles.authWrapperStyle}>
      <GoogleOAuthProvider clientId={clientId}>
        <Card className={styles.authCardStyle}>
          <GoogleLogin
            onSuccess={async (credentialResponse) => {
              console.log(credentialResponse);
              await request.post('/auth/google/token', credentialResponse);
              if (onSuccess) {
                onSuccess();
              }
            }}
            onError={() => {
              console.log('Login Failed');
            }}
          />
        </Card>
      </GoogleOAuthProvider>
    </div>
  );
};

export default GoogleAuth;
